import * as offersEditValidator from './submittedOffersEditValidator'

export const submittedOffersEditValidator = offersEditValidator

export function present (...inputs) {
  for (let input of inputs) {
    if (!input) return false
  }
  return true
}

export function validEmail (testStr) {
  var reg = new RegExp(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/)
  if (!reg.test(testStr)) {
    return false
  }
  return true
}

export function isValidPassword (testStr) {
  var reg = new RegExp(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/)
  if (!reg.test(testStr)) {
    return false
  }
  return true
}

export function undefinedField (inputs) {
  let localObj = {}
  for (let key in inputs) {
    if (!inputs[key]) {
      localObj[' ' + key[0].toUpperCase() + key.substr(1)] = inputs[key]
    }
  }
  return Object.keys(localObj).toString()
}

export function validateMobile (mobile) {
  let reg = new RegExp(/^[0-9]+$/)
  if (!reg.test(mobile)) {
    return false
  }
  return true
}

export function validateFields (input, type) {
  return {
    'length': ((input) => {
      return (!input)
        ? `${type} cannot be blank.`
        : checkInputLength(
            profileValidationRules[type].length.min,
            profileValidationRules[type].length.max,
            input
          )
          ? (profileValidationRules[type].length.max)
            ? `Length should be between ${profileValidationRules[type].length.min} -
              ${profileValidationRules[type].length.max} characters.`
            : `Length should be more than ${profileValidationRules[type].length.min}`
          : false
    })(input),
    'format': checkInputFormat(profileValidationRules[type].expression, input)
      ? `${type} is not in valid format.`
      : false
  }
}

const profileValidationRules = {
  name: {
    length: {
      min: 1,
      max: 30
    },
    expression: new RegExp(/^[a-zA-Z\s]+$/)
  },
  phone: {
    length: {
      min: 10,
      max: 13
    },
    expression: new RegExp(/^[0-9]+$/)
  },
  email: {
    length: {
      min: 6,
      max: null
    },
    expression: new RegExp(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/)
  }
}

function checkInputFormat (reg, input) {
  return !reg.test(input)
}

function checkInputLength (min, max, input) {
  if (max) {
    return (input.length >= max) || (input.length < min)
  } else {
    return (input.length < min)
  }
}

export function validateInputField (key, value, isCommonOverride) {
  let regex
  let msg = ['Values must meet the following:-', '1. Should only be numeric.', '2. Can optionally start by + or -', '3. Can have max four digits before or two digits after decimal point.']
  // if (isCommonOverride) {
  //   regex = new RegExp(/^([+-])?\d{1,4}(\.\d{1,2})?$/)
  // } else {
  // }
  regex = new RegExp(/^(\d{1,4})(\.\d{1,2})?$/)
  if (!regex.test(value)) {
    return {result: true, msg: msg}
  } else {
    return { result: false, msg: '' }
  }
}



// WEBPACK FOOTER //
// ./src/Services/Validation/index.js